module.exports = __webpack_public_path__ + "634157d444912f898ae53819f8ec6fc6.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/features_browser.png
// module id = XVmb
// module chunks = 5